<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-toggle>
        <ion-button>
          <ion-icon slot="icon-only" name="menu"></ion-icon>
        </ion-button>
      </ion-menu-toggle>

      <ion-button v-if="$route.meta.showBack" @click="$router.go(-1)">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="primary">{{ title }}</ion-title>
    <ion-buttons slot="end">

      <ion-spinner v-if="$store.state.ui.showSpinner"></ion-spinner>
      <ion-button
        v-for="(btn, idx) in $store.state.ui.moreHeaderButtons.mobile"
        @click="$root.$emit(btn.emit, $event, btn)"
        :key="idx + btn.icon"
      >
        <ion-icon slot="icon-only" v-if="!btn.icon.startsWith('custom')" :md="'md-'+btn.icon" :ios="'md-'+btn.icon"></ion-icon>
        <span v-else v-html="getIcon(btn.icon)"></span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</template>
<script>
import Icons from "../components/annot8/icons";
export default {
  computed: {
    title() {
      if (this.$store.state.ui.header && this.$store.state.ui.header.title) {
        return this.$store.state.ui.header.title;
      }
      return "";
    }
  },
  methods: {
    getIcon(icon) {
      return Icons[icon.replace('custom-', '')];
    }
  }
};
</script>
<style>
  .custom-ion-icon{
    fill: #424242;
  }
</style>
